export const ADAPTER_SESSION_ENDED_KEY = 'trivoa.auth.adapter-session-ended';
export const AUTH_SESSION_INVALIDATED_EVENT = 'trivoa:auth-session-invalidated';
export const AUTH_SESSION_RESTORED_EVENT = 'trivoa:auth-session-restored';

function browserSessionStorage(): Storage | null {
  if (typeof window === 'undefined') return null;

  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function hasAdapterSessionEnded(): boolean {
  const storage = browserSessionStorage();
  if (!storage) return true;

  try {
    return storage.getItem(ADAPTER_SESSION_ENDED_KEY) === 'true';
  } catch {
    return true;
  }
}

export function endAdapterSession(): void {
  try {
    browserSessionStorage()?.setItem(ADAPTER_SESSION_ENDED_KEY, 'true');
  } catch {
    // The active provider still transitions to signed out; future reads fail closed.
  }
}

export function resumeAdapterSession(): void {
  try {
    browserSessionStorage()?.removeItem(ADAPTER_SESSION_ENDED_KEY);
  } catch {
    return;
  }

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(AUTH_SESSION_RESTORED_EVENT));
  }
}

export function invalidateBrowserAuthSession(): void {
  endAdapterSession();
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(AUTH_SESSION_INVALIDATED_EVENT));
  }
}
